import React, { useEffect, useState } from "react";

import HttpManager from "../../../services/HttpManager";
import { errorTexto } from "./salesHelpers";

type Asesora = { id: string; name: string; roles?: string[]; team?: string };
export interface Destino { advisorId: string; plantel: number | null; }

/**
 * A quién reasignar (Esteban, 2026-10-12): las asesoras del plantel, y escondido en "Otro plantel…" las de otro plantel o
 * país (MTY↔TRC, MX↔HN). Con otro plantel, la persona se cambia de plantel al reasignar. Solo supervisión lo ve.
 */
const ReasignarDestino: React.FC<{ campusId: number; asesoras: Asesora[]; value: Destino; onChange: (v: Destino) => void; etiqueta?: (a: Asesora) => string }> = ({ campusId, asesoras, value, onChange, etiqueta }) => {
	const http = HttpManager.getInstance();
	const [otro, setOtro] = useState<boolean>(!!value.plantel);
	const [planteles, setPlanteles] = useState<{ id: number; name: string }[] | null>(null);
	const [deOtro, setDeOtro] = useState<Asesora[] | null>(null);
	const [error, setError] = useState<string | null>(null);
	const texto = etiqueta || ((a: Asesora) => a.name + (a.team ? " — " + a.team : ""));

	useEffect(() => {
		if (!otro || planteles) return;
		http.prospectsService.otroPlantel(campusId).then((r) => setPlanteles(r.data.planteles || [])).catch((e) => setError(errorTexto(e)));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [otro]);
	useEffect(() => {
		setDeOtro(null);
		if (!value.plantel) return;
		http.prospectsService.otroPlantel(campusId, value.plantel).then((r) => setDeOtro(r.data.asesoras || [])).catch((e) => setError(errorTexto(e)));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value.plantel]);

	if (!otro) {
		return (
			<>
				<select value={value.advisorId} onChange={(e) => onChange({ advisorId: e.target.value, plantel: null })} aria-label="Asesora">
					<option value="">Elegir asesora…</option>
					{asesoras.map((a) => <option key={a.id} value={a.id}>{texto(a)}</option>)}
				</select>
				<button type="button" className="enlace rd-otro" onClick={() => { setOtro(true); onChange({ advisorId: "", plantel: null }); }}>Otro plantel…</button>
			</>
		);
	}
	return (
		<>
			<select value={value.plantel || ""} onChange={(e) => onChange({ advisorId: "", plantel: e.target.value ? Number(e.target.value) : null })} aria-label="Plantel de destino" disabled={!planteles}>
				<option value="">{planteles ? "Elegir plantel…" : "Cargando planteles…"}</option>
				{(planteles || []).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
			</select>
			{value.plantel ? (
				<select value={value.advisorId} onChange={(e) => onChange({ advisorId: e.target.value, plantel: value.plantel })} aria-label="Asesora del otro plantel" disabled={!deOtro}>
					<option value="">{deOtro ? (deOtro.length ? "Elegir asesora…" : "Sin asesoras en ese plantel") : "Cargando asesoras…"}</option>
					{(deOtro || []).map((a) => <option key={a.id} value={a.id}>{texto(a)}</option>)}
				</select>
			) : null}
			{value.plantel ? <small className="rd-nota">El cliente se cambia a ese plantel.</small> : null}
			{error ? <small className="rd-nota error">{error}</small> : null}
			<button type="button" className="enlace rd-otro" onClick={() => { setOtro(false); onChange({ advisorId: "", plantel: null }); }}>Mismo plantel</button>
		</>
	);
};

export default ReasignarDestino;
